import { VerifiedIcon } from "components/icons";

export default function VerifiedComponent() {
  return (
    <span
      style={{
        display: "block",
        minWidth: "16px",
        height: "auto",
      }}
    >
      <VerifiedIcon />
    </span>
  );
}
